import axios from 'axios'
import criarToast from './ToastsHandler'
import { recuperarCookie, removerCookie } from './CookiesHandler'

const HttpClientModos = axios.create({
    baseURL: process.env.VUE_APP_MODOS_API 
});

HttpClientModos.interceptors.request.use(request => {    
    if (!request.url.endsWith('login-rpa')) {
        request.headers.common['Authorization'] = `Bearer ${ recuperarCookie('modos-token') }`    
    }
    return request;
});

HttpClientModos.interceptors.response.use(response => {
    if (response.config.method !== 'get' && response.data.message?.success) {
        if (response.config.url.includes('/gestao-equipamento/pco-cpes/filtrar-cpes')) {
            if (response.data.data.length > 0) {
                response.data.message.success.forEach(message => {
                    criarToast({
                        tipo: 'success',
                        mensagem: message
                    });
                })
            }
        } else {
            response.data.message.success.forEach(message => {
                criarToast({
                    tipo: 'success',
                    mensagem: message
                });
            })
        }
    }

    return response;

}, async(error) => {
    if (error.response?.status === 401) {
        await removerCookie('modos-token')
        return Promise.reject(error);         
    }

    if (error.response?.data) {
        let dataErrors = error.response.data.message?.errors

        if (dataErrors) {
            mostrarMensagensErro(dataErrors)
        } else {
            // esse else serve para pegar o problema de padronização no retorno das mensagens de erro
            dataErrors = error.response.data.mensagem
            if (typeof dataErrors != 'undefined') {
                dataErrors.forEach(msg => {
                    criarToast({
                        tipo: 'error',
                        mensagem: msg
                    });
                })
            } else {
                dataErrors = await error.response.data.text();
                dataErrors = JSON.parse(dataErrors).message.errors[0];

                if (typeof dataErrors == 'string') {
                    criarToast({
                        tipo: 'error',
                        mensagem: dataErrors
                    });
                } else {
                    Object.keys(dataErrors).forEach(key => {
                        criarToast({
                            tipo: 'error',
                            mensagem: dataErrors[key][0]
                        });
                    });
                }
            }            
        }   
    }

    if (error.response?.status === 500) {
        criarToast({
            tipo: 'error',
            mensagem: 'Houve um erro com o servidor, tente novamente e se o erro persistir, contate o suporte.'
        });
    }

    return Promise.reject(error);
})


function mostrarMensagensErro (dataErrors) {
    dataErrors.map(err => {

        if (typeof err === "string") {
            criarToast({
                tipo: 'error',
                mensagem: err
            });
        } else {

            const errorKeys = Object.keys(err)

            errorKeys.forEach(key => {
                err[key].forEach(message => {
                    criarToast({
                        tipo: 'error',
                        mensagem: message
                    });
                })
            })

        }

    })
}

export default HttpClientModos;
